import { Product } from './products'

/** Spa water-care products currently listed in the Pegasus online catalog. */
export const spaChemicalProducts: Product[] = [
  {
    name: 'Spa Cleaning Mitts',
    sku: '12562',
    price: 15.0,
    availability: 'In Stock',
    image: 'https://www.pegasus-spas.com/uploaded/images/BIO%20Images/0017541622141.jpg',
    alt: 'Pair of spa cleaning mitts in packaging',
  },
  {
    name: 'Anti Foam',
    sku: '12545',
    price: 16.3,
    availability: 'In Stock',
    image:
      'https://www.pegasus-spas.com/uploaded/images/BIO%20Images/2015_09_28_14.14.47_6.jpg',
    alt: 'Bottle of spa anti foam water-care product',
  },
  {
    name: 'Water Freshener',
    sku: '12546',
    price: 22.8,
    availability: 'In Stock',
    image:
      'https://www.pegasus-spas.com/uploaded/images/BIO%20Images/2015_09_28_14.14.47_7.jpg',
    alt: 'Bottle of spa water freshener',
  },
  {
    name: 'Water Clarifier',
    sku: '12544',
    price: 15.2,
    availability: 'In Stock',
    image:
      'https://www.pegasus-spas.com/uploaded/images/BIO%20Images/2015_09_28_14.14.47_8.jpg',
    alt: 'Bottle of spa water clarifier',
  },
  {
    name: 'Total Alkalinity Increaser',
    sku: '12549',
    price: 14.1,
    availability: 'In Stock',
    image:
      'https://www.pegasus-spas.com/uploaded/images/BIO%20Images/2015_09_27_12.44.03_4.jpg',
    alt: 'Container of spa total alkalinity increaser',
  },
  {
    name: 'Stain & Scale Control quart',
    sku: '12542',
    price: 32.5,
    availability: 'In Stock',
    image:
      'https://www.pegasus-spas.com/uploaded/images/BIO%20Images/2015_09_28_13.51.23_1.jpg',
    alt: 'Quart bottle of spa stain and scale control',
  },
  {
    name: 'Stain & Scale Control pint',
    sku: '12543',
    price: 26.0,
    availability: 'In Stock',
    image:
      'https://www.pegasus-spas.com/uploaded/images/BIO%20Images/2015_09_28_14.14.47_5.jpg',
    alt: 'Pint bottle of spa stain and scale control',
  },
  {
    name: 'Spa Shock 7#',
    sku: '13797',
    price: 76.8,
    availability: 'In Stock',
    image:
      'https://www.pegasus-spas.com/uploaded/images/BIO%20Images/2015_09_25_14.34.36_4.jpg',
    alt: 'Seven pound container of spa shock',
  },
]
